import { store } from '../state';
import { renderPublications, loadPublications } from './publications';
import { loadExpeditions, renderExpeditions, initEventListeners as initExpeditionsListeners } from './expeditions';
import { loadVessels, renderFleet, initEventListeners as initFleetListeners } from './vessels';
import { renderNavigation, initEventListeners as initNavigationListeners } from './navigation';
//import { renderMap, initEventListeners as initMapListeners } from './map';
//import { initEventListeners as initMapListeners } from './map';
import { initLayersPanel, renderLayersPanel } from './layers-panel';
import { initMapPanel } from './map-panels';
import { initLegendPanel } from './legend-panel'
import { initFiltersPanel } from './filters-panel';
import { initEventListeners as initPagesListeners, loadPages, renderPages } from './pages';

export function initUI(): void {
  console.log('✅ UI инициализирован');

  // Инициализация обработчиков событий (ОДИН РАЗ!)
  initNavigationListeners();
  initExpeditionsListeners();
  initFleetListeners();
//  initMapListeners();
  initLayersPanel();
  initMapPanel();
  initLegendPanel();
  initFiltersPanel();
  initPagesListeners();

  // Подписка на изменения состояния
  store.subscribe(() => {
    const state = store.getState();

    renderNavigation(state);
    // Рендерим активный раздел
    if (state.currentView === 'expeditions') {
      loadExpeditions();
      renderExpeditions(state);
    } else if (state.currentView === 'publications') {
      loadPublications();
      renderPublications(state);
    } else if (state.currentView === 'fleet') { 
      loadVessels();
      renderFleet(state); 
    } else if (state.currentView === 'map') { 
//      loadVessels();
      renderLayersPanel();
//      renderMap(state); 
    } else if (state.currentView === 'pages') {
      console.log('got rendering pages');
      loadPages();
      renderPages(state);
    }
  });

  // Инициализация при старте
  const initialState = store.getState();
  renderNavigation(initialState);
  if (initialState.currentView === 'expeditions') {
    loadExpeditions();
    renderExpeditions(initialState);
  } else if (initialState.currentView === 'publications') {
    loadPublications();
    renderPublications(initialState);
  } else if (initialState.currentView === 'fleet') {
    loadVessels();
    renderFleet(initialState);
  } else if (initialState.currentView === 'map') {
//    loadVessels();
    renderLayersPanel();
//    renderMap(initialState);
  } else if (initialState.currentView === 'pages') {
      loadPages();
      renderPages(initialState);
  }
}